import { IconCloseCircleFill } from "@synthesis/shared-icons";
import { downloadCargoFlowsTemplate } from "@synthesis/shared-services/external/dictionaries/client";
import { NoticeBase, setSnack } from "@synthesis/shared-ui";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { saveBlob } from "../../../../shared/utils/save-blob";
import { ADJACENT_CARGO_SENDER_OPTIONS, type AdjacentObjectDataFormValues } from "../../create-application-page.lib";
import { AdjacentObjectDataRadioGroup } from "./create-application-adjacent-object-data-form-controls";
import { CreateApplicationFormField, CreateApplicationFormSection } from "../create-application-form-layout";

const CARGO_FLOWS_TEMPLATE_FILE_NAME = "Грузопотоки_проекта_шаблон.xlsx";

export const AdjacentObjectCargoSection = () => {
  const methods = useFormContext<AdjacentObjectDataFormValues>();

  const handleApplicantIsCargoSenderChange = (value: string) => {
    methods.setValue("guaranteeLettersRequired", value === "no", { shouldValidate: true });
  };

  const handleDownloadCargoFlowsTemplate = useCallback(async () => {
    try {
      const response = await downloadCargoFlowsTemplate({ responseType: "blob" });
      saveBlob(response.data, CARGO_FLOWS_TEMPLATE_FILE_NAME);
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : String(error);
      setSnack({
        title: "Не удалось скачать шаблон",
        description: message,
        icon: <IconCloseCircleFill className="size-4" />,
      });
    }
  }, []);

  return (
    <CreateApplicationFormSection title="Перевозки и грузопотоки">
      <NoticeBase
        status="info"
        titleAppearance="plain"
        title="Укажите объёмы грузоперевозок и направления движения грузов (корреспонденции), которые относятся к объекту."
        description={
          <>
            Для заполнения используйте{" "}
            <button type="button" className="text-system-info-50 underline" onClick={() => void handleDownloadCargoFlowsTemplate()}>
              этот шаблон
            </button>{" "}
            — скачайте его, внесите данные по всем направлениям и загрузите файл на шаге «Документы».
          </>
        }
        className="max-w-none"
      />

      <CreateApplicationFormField label="Является ли заявитель грузоотправителем?" required>
        <AdjacentObjectDataRadioGroup
          name="applicantIsCargoSender"
          options={ADJACENT_CARGO_SENDER_OPTIONS}
          horizontal
          onChange={handleApplicantIsCargoSenderChange}
        />
      </CreateApplicationFormField>
    </CreateApplicationFormSection>
  );
};
